import "regenerator-runtime/runtime";
import { put, call, takeLatest, all } from "redux-saga/effects";
import { sendAjaxRequest } from "helper/interceptors";
import { AppSettings } from "../constants";
import * as BuilderActionType from "./constants";
import * as NotifyActionType from "Notification/constants";
import { takeEvery } from "redux-saga";

const portal = AppSettings.clientTypeValue
  ? AppSettings.clientTypeValue.toLowerCase()
  : "";

const prefixUrl = `/api/${portal}`;

export function* getByEmailAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.SITE_ONE_SERVICE_URI,
    `/api/clients/get-user-builder-by-email/${action.payload.params}`,
    {},
    "GET"
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: BuilderActionType.GET_BUILDER_BY_EMAIL_SUCCESS,
      data: { item: result.data, searchEmail: action.payload.params },
    });
  } else if (statusCode === 204) {
    yield put({
      type: BuilderActionType.GET_BUILDER_BY_EMAIL_SUCCESS,
      data: { item: null, searchEmail: action.payload.params },
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getByIdAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.SITE_ONE_SERVICE_URI,
    `/api/clients/${action.payload.params}`,
    {},
    "GET"
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: BuilderActionType.GET_BUILDER_BY_ID_SUCCESS,
      data: { item: result.data },
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* inviteBuilderAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.SITE_ONE_SERVICE_URI,
    "/api/clients/invite-builder",
    action.payload.params.data,
    "POST"
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.payload.callback) {
      action.payload.callback();
    }
    yield [
      put({ type: BuilderActionType.INVITE_BUILDER_SUCCESS, data: {} }),
      //put({ type: UserActionType.SEARCH_USER_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Invitation sent" }),
    ];
  } else {
    //TODO
    if (action.payload.callback) {
      action.payload.callback();
    }
  }
}

export function* suspendedBuilderAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.SITE_ONE_SERVICE_URI,
    "/api/clients/suspended-builder",
    action.payload.params.data,
    "POST"
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: BuilderActionType.SEARCH_BUILDER_ASYNC,
        payload: { params: action.payload.params.search },
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Builder suspended" }),
    ];
  } else {
    //TODO
  }
}

export function* restoreBuilderAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.SITE_ONE_SERVICE_URI,
    "/api/clients/restorebuilder",
    action.params.data,
    "POST"
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: BuilderActionType.SEARCH_BUILDER_ASYNC,
        params: action.params.search,
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Builder restored" }),
    ];
  } else {
    //TOTO
  }
}

export function* searchBuilderAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.SITE_ONE_SERVICE_URI,
    "/api/clients/search",
    action.payload.params,
    "GET"
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: BuilderActionType.SEARCH_BUILDER_SUCCESS,
      data: {
        data: result.data,
        params: action.payload.params,
      },
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* searchBuilderForBulkMailAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.SITE_ONE_SERVICE_URI,
    "/api/clients/search",
    action.params,
    "GET"
  );
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: BuilderActionType.SEARCH_BUILDER_FOR_BULK_MAIL_SUCCESS,
      data: result.data,
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* removeBuilderAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.SITE_ONE_SERVICE_URI,
    `/api/clients/${action.payload.params.data.id}`,
    {},
    "DELETE"
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: BuilderActionType.SEARCH_BUILDER_ASYNC,
        payload: { params: action.payload.params.search },
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Deleted" }),
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* resendActiveEmailBuilderAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.SITE_ONE_SERVICE_URI,
    "/api/clients/resend-active-email/",
    action.payload.params.data,
    "POST"
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: BuilderActionType.SEARCH_BUILDER_SUCCESS,
        payload: { params: action.payload.params.search },
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Email sent" }),
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* setUpBuilderExistedUser(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.SITE_ONE_SERVICE_URI,
    "/api/tenant/setup-builder-existed-user",
    action.payload.params,
    "POST"
  );
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: BuilderActionType.SETUP_BUILDER_USER_SUCCESS,
        data: result.data,
      }),
    ];
  } else {
    yield put({
      type: BuilderActionType.SETUP_BUILDER_USER_FAILED,
      data: { error: result.data },
    });
  }
}

export function* setUpBuilderNewUser(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.SITE_ONE_SERVICE_URI,
    "/api/tenant/setup-builder-new-user",
    action.payload.params,
    "POST"
  );
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: BuilderActionType.SETUP_BUILDER_USER_SUCCESS,
        data: result.data,
      }),
    ];
  } else {
    yield put({
      type: BuilderActionType.SETUP_BUILDER_USER_FAILED,
      data: { error: result.data },
    });
  }
}

export function* checkEmailExisting(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.SITE_ONE_SERVICE_URI,
    `${prefixUrl}/accounts/check-email-existing/${action.payload.email}`,
    {},
    "GET"
  );
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: BuilderActionType.CHECK_EMAIL_EXISTING_SUCCESS,
        data: result.data,
      }),
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* configSite(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.SITE_ONE_SERVICE_URI,
    "/api/tenant/config-site",
    action.payload,
    "POST"
  );
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: BuilderActionType.CONFIG_SITE_SUCCESS, data: result.data }),
    ];
  } else {
    yield put({
      type: BuilderActionType.CONFIG_SITE_FAILED,
      data: { error: result.data },
    });
  }
}

export function* checkAcceptedTos(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.SITE_ONE_SERVICE_URI,
    "/api/tenant/check-accepted-tos",
    action.payload,
    "POST"
  );
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: BuilderActionType.CHECK_ACCEPTED_TOS_SUCCESS,
        data: result.data,
      }),
    ];
  } else if (statusCode === 500 || statusCode === 400) {
    yield put({
      type: BuilderActionType.CHECK_ACCEPTED_TOS_FAILED,
      data: { error: "invalid" },
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* acceptTos(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.SITE_ONE_SERVICE_URI,
    `/api/tenant/accept-tos/${action.payload.code}`,
    {},
    "GET"
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: BuilderActionType.CHECK_ACCEPTED_TOS_ASYNC,
        payload: { token: action.payload.token },
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Accept success" }),
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* builderUpdateData(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    "/api/tenant/setup",
    action.payload,
    "POST"
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: BuilderActionType.BUILDER_SETUP_DATA_SUCCESS,
        data: result.data,
      }),
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* checkSetupTenantCompleted() {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    "/api/tenant/check-setup-tenant-completed",
    {},
    "GET"
  );
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: BuilderActionType.CHECK_SETUP_TENANT_COMPLETED_SUCCESS,
      data: { item: result.data },
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getBuilderAvatarNameAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.SITE_ONE_SERVICE_URI,
    `/api/builder/accounts/avatar/${action.payload.params.email}/${action.payload.params.clientId}`,
    {},
    "GET"
  );
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: BuilderActionType.GET_BUILDER_AVATAR_NAME_SUCCESS,
      data: result.data,
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* verifyTokenSetupTenantAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.SITE_ONE_SERVICE_URI,
    "/api/clients/verify-token-setup-tenant",
    action.payload.params,
    "POST"
  );
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.payload.callback) {
      action.payload.callback(result.data, true);
    }
  } else {
    if (action.payload.callback) {
      action.payload.callback(result.data, false);
    }
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* updateBuilderInformationAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.SITE_ONE_SERVICE_URI,
    `/api/clients/${action.payload.id}`,
    action.payload.params,
    "PUT"
  );
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: BuilderActionType.GET_BUILDER_BY_ID_SUCCESS,
        data: { item: result.data },
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" }),
    ];
    if (action.payload.callback) {
      action.payload.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* updateBuilderLotsAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.SITE_ONE_SERVICE_URI,
    `/api/clients/save-lot`,
    action.payload.params,
    "POST"
  );
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: BuilderActionType.GET_BUILDER_BY_ID_SUCCESS,
        data: { item: result.data },
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" }),
    ];
    if (action.payload.callback) {
      action.payload.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* updateBuilderHORFSAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.SITE_ONE_SERVICE_URI,
    `/api/clients/set-ho-rfs`,
    action.payload.params,
    "POST"
  );
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: NotifyActionType.NOTIFY_SUCCESS, data: "Saved" });
    if (action.payload.callback) {
      action.payload.callback(result);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
    if (action.payload.errorCallback) {
      action.payload.errorCallback(result);
    }
  }
}

export function* getLotStatusFeatureSaga(action) {
  try {
    const result = yield call(
      sendAjaxRequest,
      AppSettings.SITE_ONE_SERVICE_URI,
      `/api/clients/get-lot-feature`,
      { builderId: action.payload.builderId }, // Use direct property
      "GET"
    );

    if (result.statusCode === 200) {
      // Pass response to callback
      if (action.payload.callback) {
        action.payload.callback(result);
      }
    } else {
      console.error("Failed to fetch lot status:", result);
    }
  } catch (error) {
    console.error("Error in getLotStatusFeatureSaga:", error);
  }
}

export default function* WatchBuilder() {
  yield all([
    takeLatest(BuilderActionType.GET_BUILDER_BY_EMAIL_ASYNC, getByEmailAsync),
    takeLatest(BuilderActionType.GET_BUILDER_BY_ID_ASYNC, getByIdAsync),
    takeLatest(BuilderActionType.SEARCH_BUILDER_ASYNC, searchBuilderAsync),
    takeLatest(
      BuilderActionType.SEARCH_BUILDER_FOR_BULK_MAIL_ASYNC,
      searchBuilderForBulkMailAsync
    ),
    takeLatest(BuilderActionType.INVITE_BUILDER_ASYNC, inviteBuilderAsync),
    takeLatest(BuilderActionType.REMOVE_BUILDER_ASYNC, removeBuilderAsync),
    takeLatest(
      BuilderActionType.SUSPENDED_BUILDER_ASYNC,
      suspendedBuilderAsync
    ),
    takeLatest(BuilderActionType.RESTORE_BUILDER_ASYNC, restoreBuilderAsync),
    takeLatest(
      BuilderActionType.RESEND_ACTIVE_EMAIL_BUILDER_ASYNC,
      resendActiveEmailBuilderAsync
    ),
    takeLatest(
      BuilderActionType.SETUP_BUILDER_EXISTED_USER_ASYNC,
      setUpBuilderExistedUser
    ),
    takeLatest(
      BuilderActionType.SETUP_BUILDER_NEW_USER_ASYNC,
      setUpBuilderNewUser
    ),
    takeLatest(
      BuilderActionType.CHECK_EMAIL_EXISTING_ASYNC,
      checkEmailExisting
    ),
    takeLatest(BuilderActionType.CONFIG_SITE_ASYNC, configSite),
    takeLatest(BuilderActionType.CHECK_ACCEPTED_TOS_ASYNC, checkAcceptedTos),
    takeLatest(BuilderActionType.ACCEPTED_TOS_ASYNC, acceptTos),
    takeLatest(BuilderActionType.BUILDER_SETUP_DATA, builderUpdateData),
    takeLatest(
      BuilderActionType.CHECK_SETUP_TENANT_COMPLETED_ASYNC,
      checkSetupTenantCompleted
    ),
    takeLatest(
      BuilderActionType.GET_BUILDER_AVATAR_NAME_ASYNC,
      getBuilderAvatarNameAsync
    ),
    takeLatest(
      BuilderActionType.VERIFY_TOKEN_SETUP_TENANT_ASYNC,
      verifyTokenSetupTenantAsync
    ),
    takeLatest(
      BuilderActionType.UPDATE_BUILDER_INFORMATION_ASYNC,
      updateBuilderInformationAsync
    ),
    takeLatest(
      BuilderActionType.UPDATE_BUILDER_LOTS_ASYNC,
      updateBuilderLotsAsync
    ),
    takeLatest(
      BuilderActionType.GET_LOT_STATUS_FEATURE,
      getLotStatusFeatureSaga
    ),
    takeLatest(
      BuilderActionType.UPDATE_BUILDER_HO_RFS_ASYNC,
      updateBuilderHORFSAsync
    ),
  ]);
}



// WEBPACK FOOTER //
// ./src/Builders/saga.js